module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "update-status"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("StatStatus.titleChangeStatus")))]), _vm._v(" "), (_vm.msgChangeStatus[_vm.getCurrentLang()] && _vm.action.errorMsg) ? _c('p', [_vm._v(_vm._s(_vm.msgChangeStatus[_vm.getCurrentLang()]))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("StatStatus.contentStatus")) + " \"" + _vm._s(_vm.getTranslate(_vm.action.value.terms.name)) + "\"")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.hideModal($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("StatStatus.cancel")))]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.updateThisStatus(_vm.action);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("StatStatus.valider")))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54de06d5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/planos/actions/UpdateStatus.vue
// module id = 3190
// module chunks = 0